import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { resendConfirmEmail } from '@webapp/account/src/resources/profile/async';
import { selectProfileEmail, selectProfileFetch } from '@webapp/account/src/resources/profile/selectors';

import { useActions } from '@webapp/common/hooks/use-actions';

import { AuthButton, AuthConfirm, AuthHelp } from '../misc';

import { AlertMode } from './lib';

import css from './auth-alert.css';

export const AuthAlertMessage: FC<{
    setMode: (mode: AlertMode) => void;
}> = ({ setMode }) => {
    const fetch = useSelector(selectProfileFetch);
    const email = useSelector(selectProfileEmail);
    const resendConfirmEmailRequest = useActions(resendConfirmEmail);
    const setEmailMode = useCallback(() => setMode(AlertMode.EMAIL), [setMode]);

    return (
        <div>
            <AuthConfirm className={css.text}>
                Требуется подтвердить email, пройдя по ссылке, отправленной на: <br />
                <span className={css.email}>{email}</span>
            </AuthConfirm>
            <AuthHelp className={css.text}>Если письмо долго не приходит, проверьте папку Спам</AuthHelp>
            <div className={css.actions}>
                <AuthButton className={css.resend} type='button' onClick={resendConfirmEmailRequest}>
                    {fetch ? 'Отправка...' : 'Отправить повторно'}
                </AuthButton>
                <AuthButton className={css.change} type='button' onClick={setEmailMode}>
                    Изменить email
                </AuthButton>
            </div>
        </div>
    );
};
